import TabbedDisplay from 'modules/TabbedDisplay'

import FullReportPage from 'routes/common/FullReportPage'
import ResearchBriefsPage from 'routes/common/FullReportPage/components/ResearchBriefs'
import Dashboard from 'routes/dashboard'

import { TableauEmbed } from 'components'

import { ISingleCustomPage } from 'interfaces/navigationPage.interface'

import { getMediaDefaultWidget } from 'config/common/baseModel/Media'
import { getPressReleasesDefaultWidget } from 'config/common/baseModel/PressReleases'

import CombinationVaccinesReport from './CombinationVaccinesReports'
import { VaccinesSlugs } from './VaccinesMenu'
import {
  VaccineCampaignsPages,
  VaccinesPages,
  VaccinesResults,
} from './VaccinesPages'
import NewsletterPage from 'routes/common/FullReportPage/components/NewsletterPage'
import NewNotePopover from 'components/PageHeader/NewNotePopover'
import SingleReportByID from 'routes/common/SingleReportByID'
import InfluenzaPageBanner from 'components/PageBanner/Influenza'
import EpidemiologyDashboardBanner from 'components/PageBanner/EpidemiologyDashboard'

const LatestNewsPage: ISingleCustomPage<VaccinesSlugs> = {
  path: '',
  component: () => {
    return (
      <>
        <Dashboard
          widgetTabs={[
            getMediaDefaultWidget({ view: VaccinesPages['Media'].views[0] }),
            getPressReleasesDefaultWidget({
              view: VaccinesPages['PressReleases'].views[0],
            }),
          ]}
        />
      </>
    )
  },
}

const Reports: ISingleCustomPage<VaccinesSlugs> = {
  path: ['reports'],
  component: () => <FullReportPage showCategory={false} showAppFilter />,
}
const CustomReports: ISingleCustomPage<VaccinesSlugs> = {
  path: ['combination-vaccines'],
  component: () => (
    <>
      <EpidemiologyDashboardBanner
        mb={5}
        href='/epidemiology/overview/epidemiology-across-respiratory-diseases'
      />
      <TabbedDisplay
        tabs={[
          {
            heading: 'Read Latest Combination Vaccines Analysis',
            body: (
              <CombinationVaccinesReport title='Combination Vaccines Approval Timelines and Results' />
            ),
          },
          {
            heading: 'Combination Vaccine Results Dashboard',
            body: (
              <TableauEmbed path='/Combinationcomparativeimmunogenicity_17195769565230/Dashboard1_1' />
            ),
          },
        ]}
      />
    </>
  ),
}

const ResearchBriefs: ISingleCustomPage<VaccinesSlugs> = {
  path: ['reports', 'research-briefs'],
  component: () => <ResearchBriefsPage />,
}

const ApprovalsOverviewDashboard: ISingleCustomPage<VaccinesSlugs> = {
  path: ['regulatory', 'total-per-country-vaccine'],
  component: () => (
    <TableauEmbed path='/updated_vacc_approvals/Approvals_overview' />
  ),
}

const VaccinesApprovalThisWeek: ISingleCustomPage<VaccinesSlugs> = {
  path: ['regulatory', 'this-week'],
  component: () => <TableauEmbed path='/Approvals_Weekly_Updates/Dashboard1' />,
}

const BoosterCampaigns: ISingleCustomPage<VaccinesSlugs> = {
  path: ['booster-campaigns'],
  component: () => (
    <TabbedDisplay
      tabs={[
        {
          heading: 'JN.1 Regulatory Decisions',
          body: (
            <TableauEmbed
              path='/JN_1vaccineregulatorydecisions/JN_1approvals'
              height='150vh'
            />
          ),
        },
        {
          heading: 'Vaccine Campaigns Table',
          body: Object.values(VaccineCampaignsPages)[0],
        },
      ]}
    />
  ),
}

const RecentTrialsMap: ISingleCustomPage<VaccinesSlugs> = {
  path: ['trials', 'recent-trials-map'],
  component: () => (
    <TableauEmbed
      path='/Clinical_trials_COVID_Flu_RSV/Clinicaltrials_COVID'
      height='140vh'
    />
  ),
}
const LandscapeDashboard: ISingleCustomPage<VaccinesSlugs> = {
  path: ['trials', 'landscape'],
  component: () => (
    <TableauEmbed path='/COVIDtrialsfinal/Timetotal' height='140vh' />
  ),
}

const ComparativeImmunogenicityDashboard: ISingleCustomPage<VaccinesSlugs> = {
  path: ['results', 'comparative-immunogenicity'],
  component: () => (
    <TableauEmbed
      path='/Pivotalimmunogenicityresults/Dashboard2'
      height='130vh'
    />
  ),
}

const UpdatedVaccineEffectivenessTabs: ISingleCustomPage<VaccinesSlugs> = {
  path: ['results', 'updated-vaccine-effectiveness'],
  component: () => (
    <TabbedDisplay
      tabs={[
        {
          heading: 'JN.1/KP.2 Vaccines',
          body: (
            <TableauEmbed
              path='/JN1_KP2effectiveness/Dashboard1'
              height='130vh'
            />
          ),
        },
        {
          heading: 'XBB Vaccines',
          body: (
            <TableauEmbed
              path='/XBBVaccineEffectiveness/Dashboardfinal'
              height='80vh'
            />
          ),
        },
        {
          heading: 'Bivalent mRNA Vaccines',
          body: (
            <TableauEmbed
              path='/BivalentmRNAVaccineEffectiveness/Dashboardfinal'
              height='130vh'
            />
          ),
        },
      ]}
    />
  ),
}
const HistoricalResultsDataTabs: ISingleCustomPage<VaccinesSlugs> = {
  path: ['results', 'historical-results-data'],
  component: () => (
    <TabbedDisplay
      tabs={[
        {
          heading: 'Real World',
          body: Object.values(VaccinesResults)[0],
        },
        {
          heading: 'Phase III',
          body: Object.values(VaccinesResults)[1],
        },
      ]}
    />
  ),
}
const ProgressTrackerDashboard: ISingleCustomPage<VaccinesSlugs> = {
  path: ['candidates', 'progress-tracker'],
  component: () => (
    <TabbedDisplay
      tabs={[
        {
          heading: 'Overall Progress',
          body: (
            <TableauEmbed
              path='/frontendcovidvaccinesprogresstracker/OverallProgressbyPhase_1'
              height='80vh'
            />
          ),
        },
        {
          heading: 'Metric Breakdown',
          body: (
            <TableauEmbed
              path='/frontendcovidvaccinesprogresstracker/ProgressbyMetric'
              height='80vh'
            />
          ),
        },
      ]}
    />
  ),
}

const ConferencesDebriefs: ISingleCustomPage<VaccinesSlugs> = {
  path: ['conferences', 'debriefs'],
  component: () => (
    <>
      <NewNotePopover
        message={`Our daily debriefs, covering all of the important scientific and commercial content during conferences, 
          are now available on the platform. If you would like a briefing on our conference insights, 
          please speak to your account manager or email infectiousdiseases@airfinity.com`}
        newUntil={new Date(2024, 11, 1)}
      />
      <InfluenzaPageBanner mb={'1rem'} />
      <NewsletterPage
        endpoint='/lzdb/demo-vaccines/newsletters/conference/'
        summaryRowIndex={6}
        title='Conferences Newsletters'
      />
    </>
  ),
}
const ConferencesDeepDives: ISingleCustomPage<VaccinesSlugs> = {
  path: ['conferences', 'deep-dives'],
  component: () => (
    <>
      <NewNotePopover
        message={`Our daily debriefs, covering all of the important scientific and commercial content during conferences, 
      are now available on the platform. If you would like a briefing on our conference insights, 
      please speak to your account manager or email infectiousdiseases@airfinity.com`}
        newUntil={new Date(2024, 11, 1)}
      />
      <InfluenzaPageBanner mb={'1rem'} />
      <SingleReportByID title='Conferences Deep Dives' id='1548' />
    </>
  ),
}

export const VaccinesCustomPages: Record<
  string,
  ISingleCustomPage<VaccinesSlugs>
> = {
  LatestNewsPage,
  Reports,
  ResearchBriefs,
  CustomReports,
  VaccinesApprovalThisWeek,
  RecentTrialsMap,
  ProgressTrackerDashboard,
  BoosterCampaigns,
  LandscapeDashboard,
  ApprovalsOverviewDashboard,
  ComparativeImmunogenicityDashboard,
  UpdatedVaccineEffectivenessTabs,
  HistoricalResultsDataTabs,
  ConferencesDeepDives,
  ConferencesDebriefs,
}
